import { NestedCSSProperties } from 'typestyle/lib/types';
import { colorBlueGrey, colorBrand, colorGreyAccent, colorWhite } from '../../theme/color';
import { style } from 'typestyle';
import { em, px } from 'csx';

const borderStyle = `${px(1)} solid ${colorGreyAccent.toHexString()}`;

export const TabsWrapper: NestedCSSProperties = {
  borderBottom: borderStyle,
};

export const TabsList: NestedCSSProperties = {
  display: 'flex',
  listStyle: 'none',
  justifyContent: 'space-between',
  margin: 0,
  padding: 0,
};

export const TabsListItem: NestedCSSProperties = {
  width: '50%',
  height: '36px',
  border: borderStyle,
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
  textAlign: 'center',
  backgroundColor: 'white',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  $nest: {
    '&.selected': {
      borderBottom: 0,
    },
  },
};

export const TabsListItemText: NestedCSSProperties = {
  color: 'white',
  backgroundColor: colorBlueGrey.toHexString(),
  borderRadius: em(1),
  fontSize: px(10),
  lineHeight: px(16),
  minWidth: px(16),
  padding: '0 5px',
  $nest: {
    '.selected > &': {
      backgroundColor: colorBrand.toHexString(),
    },
  },
};

export const TabWrapper: NestedCSSProperties = {
  backgroundColor: colorWhite.toHexString(),
  padding: px(16),
};

export default {
  wrapper: style(TabsWrapper),
  list: style(TabsList),
  listItem: style(TabsListItem),
  listItemText: style(TabsListItemText),
  tabWrapper: style(TabWrapper),
};
